const a = {
  addToFolder: () => import("./index.es27.js"),
  addedtoFolder: () => import("./index.es28.js"),
  alarmBell: () => import("./index.es29.js"),
  alignBottom: () => import("./index.es30.js"),
  alignCenter: () => import("./index.es31.js"),
  alignLeft: () => import("./index.es32.js"),
  alignMiddle: () => import("./index.es33.js"),
  alignRight: () => import("./index.es34.js"),
  alignTop: () => import("./index.es35.js"),
  amex: () => import("./index.es36.js"),
  applePay: () => import("./index.es37.js"),
  arrowBack: () => import("./index.es38.js"),
  arrowCursorBlue: () => import("./index.es39.js"),
  arrowCursorPink: () => import("./index.es40.js"),
  arrowCursorYellow: () => import("./index.es41.js"),
  arrowDown: () => import("./index.es42.js"),
  arrowRight: () => import("./index.es43.js"),
  arrowUp: () => import("./index.es44.js"),
  attachment: () => import("./index.es45.js"),
  audioModified: () => import("./index.es46.js"),
  blankCalendarBlue: () => import("./index.es47.js"),
  blankCalendarPink: () => import("./index.es48.js"),
  blankCalendarYellow: () => import("./index.es49.js"),
  businessStartupBlue: () => import("./index.es50.js"),
  businessStartupPink: () => import("./index.es51.js"),
  businessStartupYellow: () => import("./index.es52.js"),
  calendar: () => import("./index.es53.js"),
  cameraBlue: () => import("./index.es54.js"),
  cameraPink: () => import("./index.es55.js"),
  cameraYellow: () => import("./index.es56.js"),
  cameraVideoBlue: () => import("./index.es57.js"),
  cameraVideoPink: () => import("./index.es58.js"),
  cameraVideoYellow: () => import("./index.es59.js"),
  chatBubbleTypingOvalBlue: () => import("./index.es60.js"),
  chatBubbleTypingOvalPink: () => import("./index.es61.js"),
  chatBubbleTypingOvalYellow: () => import("./index.es62.js"),
  chatTwoBubblesSquareBlue: () => import("./index.es63.js"),
  chatTwoBubblesSquarePink: () => import("./index.es64.js"),
  chatTwoBubblesSquareYellow: () => import("./index.es65.js"),
  check: () => import("./index.es66.js"),
  checkCircle: () => import("./index.es67.js"),
  chevronDown: () => import("./index.es68.js"),
  chevronLeft: () => import("./index.es69.js"),
  chevronRight: () => import("./index.es70.js"),
  chevronUp: () => import("./index.es71.js"),
  circleClockBlue: () => import("./index.es72.js"),
  circleClockPink: () => import("./index.es73.js"),
  circleClockYellow: () => import("./index.es74.js"),
  close: () => import("./index.es75.js"),
  cog: () => import("./index.es76.js"),
  compass: () => import("./index.es77.js"),
  controlsForward: () => import("./index.es78.js"),
  controlsPause: () => import("./index.es79.js"),
  controlsPlay: () => import("./index.es80.js"),
  controlsRecord: () => import("./index.es81.js"),
  controlsRewind: () => import("./index.es82.js"),
  controlsStop: () => import("./index.es83.js"),
  dashboardGaugeBlue: () => import("./index.es84.js"),
  dashboardGaugePink: () => import("./index.es85.js"),
  dashboardGaugeYellow: () => import("./index.es86.js"),
  dinersClub: () => import("./index.es87.js"),
  discover: () => import("./index.es88.js"),
  downloadBottom: () => import("./index.es89.js"),
  downloadSquareBlue: () => import("./index.es90.js"),
  downloadSquarePink: () => import("./index.es91.js"),
  downloadSquareYellow: () => import("./index.es92.js"),
  dropbox: () => import("./index.es93.js"),
  emptyClipboardBlue: () => import("./index.es94.js"),
  emptyClipboardPink: () => import("./index.es95.js"),
  emptyClipboardYellow: () => import("./index.es96.js"),
  erlenmeyerFlaskBlue: () => import("./index.es97.js"),
  erlenmeyerFlaskPink: () => import("./index.es98.js"),
  erlenmeyerFlaskYellow: () => import("./index.es99.js"),
  error: () => import("./index.es100.js"),
  expandHorizontal: () => import("./index.es101.js"),
  expandVertical: () => import("./index.es102.js"),
  facebook: () => import("./index.es103.js"),
  favorite: () => import("./index.es104.js"),
  favoriteFilled: () => import("./index.es105.js"),
  fileDouble: () => import("./index.es106.js"),
  filter: () => import("./index.es107.js"),
  filterImage: () => import("./index.es108.js"),
  filterMusic: () => import("./index.es109.js"),
  filterPlus: () => import("./index.es110.js"),
  filterVideo: () => import("./index.es111.js"),
  folderStar: () => import("./index.es112.js"),
  gitHub: () => import("./index.es113.js"),
  googlePay: () => import("./index.es114.js"),
  graphPieChartBlue: () => import("./index.es115.js"),
  graphPieChartPink: () => import("./index.es116.js"),
  graphPieChartYellow: () => import("./index.es117.js"),
  gridRulesBlue: () => import("./index.es118.js"),
  gridRulesPink: () => import("./index.es119.js"),
  gridRulesYellow: () => import("./index.es120.js"),
  happyFaceBlue: () => import("./index.es121.js"),
  happyFacePink: () => import("./index.es122.js"),
  happyFaceYellow: () => import("./index.es123.js"),
  headphonesCustomer: () => import("./index.es124.js"),
  helpChatBlue: () => import("./index.es125.js"),
  helpChatPink: () => import("./index.es126.js"),
  helpChatYellow: () => import("./index.es127.js"),
  homeBlue: () => import("./index.es128.js"),
  homePink: () => import("./index.es129.js"),
  homeYellow: () => import("./index.es130.js"),
  hourGlassBlue: () => import("./index.es131.js"),
  hourGlassPink: () => import("./index.es132.js"),
  hourGlassYellow: () => import("./index.es133.js"),
  house: () => import("./index.es134.js"),
  imageModified: () => import("./index.es135.js"),
  informationCircle: () => import("./index.es136.js"),
  instagram: () => import("./index.es137.js"),
  interfaceAlertAlarmBellBlue: () => import("./index.es138.js"),
  interfaceAlertAlarmBellPink: () => import("./index.es139.js"),
  interfaceAlertAlarmBellYellow: () => import("./index.es140.js"),
  interfaceAwardTrophyBlue: () => import("./index.es141.js"),
  interfaceAwardTrophyPink: () => import("./index.es142.js"),
  interfaceAwardTrophyYellow: () => import("./index.es143.js"),
  interfaceCursorArrowBlue: () => import("./index.es144.js"),
  interfaceCursorArrowPink: () => import("./index.es145.js"),
  interfaceCursorArrowYellow: () => import("./index.es146.js"),
  interfaceFavoriteLikeBlue: () => import("./index.es147.js"),
  interfaceFavoriteLikePink: () => import("./index.es148.js"),
  interfaceFavoriteLikeYellow: () => import("./index.es149.js"),
  interfaceImageVideoAudioSubtitlesBlue: () => import("./index.es150.js"),
  interfaceImageVideoAudioSubtitlesPink: () => import("./index.es151.js"),
  interfaceImageVideoAudioSubtitlesYellow: () => import("./index.es152.js"),
  interfaceLightingLightBulbBlue: () => import("./index.es153.js"),
  interfaceLightingLightBulbPink: () => import("./index.es154.js"),
  interfaceLightingLightBulbYellow: () => import("./index.es155.js"),
  interfaceSearchBlue: () => import("./index.es156.js"),
  interfaceSearchPink: () => import("./index.es157.js"),
  interfaceSearchYellow: () => import("./index.es158.js"),
  keyboardBlue: () => import("./index.es159.js"),
  keyboardPink: () => import("./index.es160.js"),
  keyboardYellow: () => import("./index.es161.js"),
  keyboardArrowRight: () => import("./index.es162.js"),
  layersBlue: () => import("./index.es163.js"),
  layersPink: () => import("./index.es164.js"),
  layersYellow: () => import("./index.es165.js"),
  layoutWindowBlue: () => import("./index.es166.js"),
  layoutWindowPink: () => import("./index.es167.js"),
  layoutWindowYellow: () => import("./index.es168.js"),
  linkedIn: () => import("./index.es169.js"),
  lock: () => import("./index.es170.js"),
  lockUnlock: () => import("./index.es171.js"),
  loginBlue: () => import("./index.es172.js"),
  loginPink: () => import("./index.es173.js"),
  loginYellow: () => import("./index.es174.js"),
  logoStoryblocks: () => import("./index.es175.js"),
  logoStoryblocksGray: () => import("./index.es176.js"),
  logoStoryblocksWhite: () => import("./index.es177.js"),
  maestro: () => import("./index.es178.js"),
  magicWandBlue: () => import("./index.es179.js"),
  magicWandPink: () => import("./index.es180.js"),
  magicWandYellow: () => import("./index.es181.js"),
  maker: () => import("./index.es182.js"),
  mastercard: () => import("./index.es183.js"),
  megaphoneBlue: () => import("./index.es184.js"),
  megaphonePink: () => import("./index.es185.js"),
  megaphoneYellow: () => import("./index.es186.js"),
  microphone: () => import("./index.es187.js"),
  microphoneOff: () => import("./index.es188.js"),
  moneyCashBillBlue: () => import("./index.es189.js"),
  moneyCashBillPink: () => import("./index.es190.js"),
  moneyCashBillYellow: () => import("./index.es191.js"),
  moneyWalletBlue: () => import("./index.es192.js"),
  moneyWalletPink: () => import("./index.es193.js"),
  moneyWalletYellow: () => import("./index.es194.js"),
  musicSound: () => import("./index.es195.js"),
  navigationMenuHorizontal: () => import("./index.es196.js"),
  navigationMenuVertical: () => import("./index.es197.js"),
  newStickyNoteBlue: () => import("./index.es198.js"),
  newStickyNotePink: () => import("./index.es199.js"),
  newStickyNoteYellow: () => import("./index.es200.js"),
  oneFingerTapBlue: () => import("./index.es201.js"),
  oneFingerTapPink: () => import("./index.es202.js"),
  oneFingerTapYellow: () => import("./index.es203.js"),
  openBookBlue: () => import("./index.es204.js"),
  openBookPink: () => import("./index.es205.js"),
  openBookYellow: () => import("./index.es206.js"),
  paragraphLeftAlign: () => import("./index.es207.js"),
  paragraphsCenterAlign: () => import("./index.es208.js"),
  paragraphsRightAlign: () => import("./index.es209.js"),
  payPal: () => import("./index.es210.js"),
  penBlue: () => import("./index.es211.js"),
  penPink: () => import("./index.es212.js"),
  penYellow: () => import("./index.es213.js"),
  pencil: () => import("./index.es214.js"),
  picturesFolderMemoriesBlue: () => import("./index.es215.js"),
  picturesFolderMemoriesPink: () => import("./index.es216.js"),
  picturesFolderMemoriesYellow: () => import("./index.es217.js"),
  pinBlue: () => import("./index.es218.js"),
  pinPink: () => import("./index.es219.js"),
  pinYellow: () => import("./index.es220.js"),
  pinterest: () => import("./index.es221.js"),
  playListBlue: () => import("./index.es222.js"),
  playListPink: () => import("./index.es223.js"),
  playListYellow: () => import("./index.es224.js"),
  playVideo: () => import("./index.es225.js"),
  plus: () => import("./index.es226.js"),
  profileAvatar: () => import("./index.es227.js"),
  questionmark: () => import("./index.es228.js"),
  refresh: () => import("./index.es229.js"),
  screenTvBlue: () => import("./index.es230.js"),
  screenTvPink: () => import("./index.es231.js"),
  screenTvYellow: () => import("./index.es232.js"),
  scriptBlue: () => import("./index.es233.js"),
  scriptPink: () => import("./index.es234.js"),
  scriptYellow: () => import("./index.es235.js"),
  search: () => import("./index.es236.js"),
  searchSimilar: () => import("./index.es237.js"),
  settingMenu: () => import("./index.es238.js"),
  share: () => import("./index.es239.js"),
  shoppingCartBlue: () => import("./index.es240.js"),
  shoppingCartPink: () => import("./index.es241.js"),
  shoppingCartYellow: () => import("./index.es242.js"),
  snapchat: () => import("./index.es243.js"),
  stamp: () => import("./index.es244.js"),
  stopwatchBlue: () => import("./index.es245.js"),
  stopwatchPink: () => import("./index.es246.js"),
  stopwatchYellow: () => import("./index.es247.js"),
  stripe: () => import("./index.es248.js"),
  sunCloudBlue: () => import("./index.es249.js"),
  sunCloudPink: () => import("./index.es250.js"),
  sunCloudYellow: () => import("./index.es251.js"),
  textBold: () => import("./index.es252.js"),
  textInputArea: () => import("./index.es253.js"),
  textItalic: () => import("./index.es254.js"),
  textStrikeThrough: () => import("./index.es255.js"),
  textStyle: () => import("./index.es256.js"),
  textUnderline: () => import("./index.es257.js"),
  thirdEye: () => import("./index.es258.js"),
  trash: () => import("./index.es259.js"),
  travelMapEarthBlue: () => import("./index.es260.js"),
  travelMapEarthPink: () => import("./index.es261.js"),
  travelMapEarthYellow: () => import("./index.es262.js"),
  twitter: () => import("./index.es263.js"),
  uploadBottom: () => import("./index.es264.js"),
  uploadCircleBlue: () => import("./index.es265.js"),
  uploadCirclePink: () => import("./index.es266.js"),
  uploadCircleYellow: () => import("./index.es267.js"),
  userCircleSingleBlue: () => import("./index.es268.js"),
  userCircleSinglePink: () => import("./index.es269.js"),
  userCircleSingleYellow: () => import("./index.es270.js"),
  userSingleBlue: () => import("./index.es271.js"),
  userSinglePink: () => import("./index.es272.js"),
  userSingleYellow: () => import("./index.es273.js"),
  venmo: () => import("./index.es274.js"),
  verticalSliderSquareBlue: () => import("./index.es275.js"),
  verticalSliderSquarePink: () => import("./index.es276.js"),
  verticalSliderSquareYellow: () => import("./index.es277.js"),
  videoEditPeel: () => import("./index.es278.js"),
  videoEditSplit: () => import("./index.es279.js"),
  videoModified: () => import("./index.es280.js"),
  view: () => import("./index.es281.js"),
  viewOff: () => import("./index.es282.js"),
  visa: () => import("./index.es283.js"),
  voiceMailBlue: () => import("./index.es284.js"),
  voiceMailPink: () => import("./index.es285.js"),
  voiceMailYellow: () => import("./index.es286.js"),
  volumeDown: () => import("./index.es287.js"),
  volumeLevelHighBlue: () => import("./index.es288.js"),
  volumeLevelHighPink: () => import("./index.es289.js"),
  volumeLevelHighYellow: () => import("./index.es290.js"),
  volumeMedium: () => import("./index.es291.js"),
  volumeOff: () => import("./index.es292.js"),
  volumeUp: () => import("./index.es293.js"),
  warningTriangle: () => import("./index.es294.js"),
  webcamVideoBlue: () => import("./index.es295.js"),
  webcamVideoPink: () => import("./index.es296.js"),
  webcamVideoYellow: () => import("./index.es297.js"),
  youtube: () => import("./index.es298.js")
}, t = /* @__PURE__ */ new Set([
  "arrowCursor",
  "blankCalendar",
  "businessStartup",
  "camera",
  "cameraVideo",
  "chatBubbleTypingOval",
  "chatTwoBubblesSquare",
  "circleClock",
  "dashboardGauge",
  "downloadSquare",
  "emptyClipboard",
  "erlenmeyerFlask",
  "graphPieChart",
  "gridRules",
  "happyFace",
  "helpChat",
  "home",
  "hourGlass",
  "interfaceAlertAlarmBell",
  "interfaceAwardTrophy",
  "interfaceCursorArrow",
  "interfaceFavoriteLike",
  "interfaceImageVideoAudioSubtitles",
  "interfaceLightingLightBulb",
  "interfaceSearch",
  "keyboard",
  "layers",
  "layoutWindow",
  "login",
  "magicWand",
  "megaphone",
  "moneyCashBill",
  "moneyWallet",
  "newStickyNote",
  "oneFingerTap",
  "openBook",
  "pen",
  "picturesFolderMemories",
  "pin",
  "playList",
  "screenTv",
  "script",
  "shoppingCart",
  "stopwatch",
  "sunCloud",
  "travelMapEarth",
  "uploadCircle",
  "userCircleSingle",
  "userSingle",
  "verticalSliderSquare",
  "voiceMail",
  "volumeLevelHigh",
  "webcamVideo"
]), p = {
  arrowCursor: ["blue", "pink", "yellow"],
  blankCalendar: ["blue", "pink", "yellow"],
  businessStartup: ["blue", "pink", "yellow"],
  camera: ["blue", "pink", "yellow"],
  cameraVideo: ["blue", "pink", "yellow"],
  chatBubbleTypingOval: ["blue", "pink", "yellow"],
  chatTwoBubblesSquare: ["blue", "pink", "yellow"],
  circleClock: ["blue", "pink", "yellow"],
  dashboardGauge: ["blue", "pink", "yellow"],
  downloadSquare: ["blue", "pink", "yellow"],
  emptyClipboard: ["blue", "pink", "yellow"],
  erlenmeyerFlask: ["blue", "pink", "yellow"],
  graphPieChart: ["blue", "pink", "yellow"],
  gridRules: ["blue", "pink", "yellow"],
  happyFace: ["blue", "pink", "yellow"],
  helpChat: ["blue", "pink", "yellow"],
  home: ["blue", "pink", "yellow"],
  hourGlass: ["blue", "pink", "yellow"],
  interfaceAlertAlarmBell: ["blue", "pink", "yellow"],
  interfaceAwardTrophy: ["blue", "pink", "yellow"],
  interfaceCursorArrow: ["blue", "pink", "yellow"],
  interfaceFavoriteLike: ["blue", "pink", "yellow"],
  interfaceImageVideoAudioSubtitles: ["blue", "pink", "yellow"],
  interfaceLightingLightBulb: ["blue", "pink", "yellow"],
  interfaceSearch: ["blue", "pink", "yellow"],
  keyboard: ["blue", "pink", "yellow"],
  layers: ["blue", "pink", "yellow"],
  layoutWindow: ["blue", "pink", "yellow"],
  login: ["blue", "pink", "yellow"],
  magicWand: ["blue", "pink", "yellow"],
  megaphone: ["blue", "pink", "yellow"],
  moneyCashBill: ["blue", "pink", "yellow"],
  moneyWallet: ["blue", "pink", "yellow"],
  newStickyNote: ["blue", "pink", "yellow"],
  oneFingerTap: ["blue", "pink", "yellow"],
  openBook: ["blue", "pink", "yellow"],
  pen: ["blue", "pink", "yellow"],
  picturesFolderMemories: ["blue", "pink", "yellow"],
  pin: ["blue", "pink", "yellow"],
  playList: ["blue", "pink", "yellow"],
  screenTv: ["blue", "pink", "yellow"],
  script: ["blue", "pink", "yellow"],
  shoppingCart: ["blue", "pink", "yellow"],
  stopwatch: ["blue", "pink", "yellow"],
  sunCloud: ["blue", "pink", "yellow"],
  travelMapEarth: ["blue", "pink", "yellow"],
  uploadCircle: ["blue", "pink", "yellow"],
  userCircleSingle: ["blue", "pink", "yellow"],
  userSingle: ["blue", "pink", "yellow"],
  verticalSliderSquare: ["blue", "pink", "yellow"],
  voiceMail: ["blue", "pink", "yellow"],
  volumeLevelHigh: ["blue", "pink", "yellow"],
  webcamVideo: ["blue", "pink", "yellow"]
};
function m(e, o) {
  let r = e;
  if (t.has(e)) {
    const i = p[e] || [], l = o || i[0];
    if (o && !i.includes(o))
      return console.error(
        'Invalid variant "' + o + '" for icon "' + e + '". Available variants: ' + i.join(", ")
      ), null;
    r = e + l.charAt(0).toUpperCase() + l.slice(1);
  } else o && console.warn('Icon "' + e + '" does not support variants. Ignoring variant "' + o + '".');
  return a[r] || null;
}
function n(e) {
  return t.has(e);
}
function u(e) {
  const o = p[e];
  return o ? o[0] : void 0;
}
export {
  u as getDefaultVariant,
  m as getIconImport,
  n as hasVariants
};
